import { SportIDs } from "./sport";

const periods = {
  P_FT_ID: 1,  // Full Time
  P_1H_ID: 2,
  P_2H_ID: 3,
  P_1P_ID: 5,
  P_2P_ID: 6,
  P_3P_ID: 7,
  P_1Q_ID: 8,
  P_2Q_ID: 9,
  P_3Q_ID: 10,
  P_4Q_ID: 11,
  P_1S_ID: 12,
  P_2S_ID: 13,
  P_3S_ID: 14,
  P_4S_ID: 15,
  P_5S_ID: 16,
  P_FE_ID: 120,  // Full Event
}


export function getPeriodIdsBySportId(sportId?: number): number[] {
  switch (sportId) {
    case SportIDs.Football:
    case SportIDs.Handball:
      return [periods.P_FT_ID, periods.P_1H_ID, periods.P_2H_ID];

    case SportIDs.Tennis:
      return [periods.P_FE_ID, periods.P_1S_ID, periods.P_2S_ID, periods.P_3S_ID, periods.P_4S_ID, periods.P_5S_ID];

    case SportIDs.IceHockey:
    case SportIDs.Hockey:
      return [periods.P_FT_ID, periods.P_FE_ID, periods.P_1P_ID, periods.P_2P_ID, periods.P_3P_ID];

    case SportIDs.Basketball:
    case SportIDs.AmericanFootball:
      return [periods.P_FE_ID, periods.P_FT_ID, periods.P_1Q_ID, periods.P_2Q_ID, periods.P_3Q_ID, periods.P_4Q_ID];

    default:
      return [periods.P_FE_ID];
  }
}

export function getPeriodShortName(periodId: number): string {
  switch (periodId) {
    case periods.P_FT_ID:
      return 'FT';

    case periods.P_1H_ID:
      return '1H';

    case periods.P_2H_ID:
      return '2H';

    case periods.P_FE_ID:
      return 'FE';

    case periods.P_1P_ID:
      return '1P';

    case periods.P_2P_ID:
      return '2P';

    case periods.P_3P_ID:
      return '3P';

    case periods.P_1Q_ID:
      return '1Q';

    case periods.P_2Q_ID:
      return '2Q';

    case periods.P_3Q_ID:
      return '3Q';

    case periods.P_4Q_ID:
      return '4Q';

    case periods.P_1S_ID:
      return '1S';

    case periods.P_2S_ID:
      return '2S';

    case periods.P_3S_ID:
      return '3S';

    case periods.P_4S_ID:
      return '4S';

    case periods.P_5S_ID:
      return '5S';
  }

  return 'Period ' + periodId;
}



export default periods;
